import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { ContextLibraryFileUploadInput, ContextLibraryFileUploadPayload } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TVariables = ContextLibraryFileUploadInput;
type TData = ContextLibraryFileUploadPayload;

export const useContextLibraryUpload = (
  options: Omit<UseMutationOptions<TData, TGenericError, TVariables, unknown>, 'mutationFn'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    mutation contextLibraryFileUpload($input: ContextLibraryFileUploadInput!) {
      contextLibraryFileUpload(input: $input) {
        success
        errors
        errorCode
        tags
        file {
          filename
          filesize
        }
      }
    }
  `;

  return useMutation<TData, TGenericError, TVariables, unknown>({
    mutationFn: (input: TVariables): Promise<TData> =>
      client.request({
        data: {
          gql: graphql,
          variables: { input }
        }
      }),
    ...options
  });
};
